export const getHost = (): string => {
  return window.location.origin.includes('localhost') ? 'http://localhost:8082' : window.location.origin
}
